import { HttpContext } from "@angular/common/http";
import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import {
  EntityModelLipidMapsEntry,
  LipidMapsEntry,
  LipidMapsEntryControllerService,
  PagedModelEntityModelLipidMapsEntry
} from "../../../../modules/lipidcompass-backend-client";
import { CrudAdapter } from "../../layouts/crud-table/crud-adapter";
import { ColumnFilterType, TableColumn } from "../../_models/table-column";
import {
  JobsService,
  JobFileInputDto
} from "../../../../modules/lipidcompass-data-importer-client";
import { LoggingService } from "../../_services/logging.service";
import { CrudTableComponent } from "../../layouts/crud-table/crud-table.component";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-admin-lipidmaps",
  templateUrl: "./admin-lipidmaps.component.html",
  styleUrls: ["./admin-lipidmaps.component.css"],
  standalone: true,
  imports: [ButtonModule, CrudTableComponent, SelectModule, FormsModule]
})
export class AdminLipidMapsComponent implements OnInit {
  private controller = inject(LipidMapsEntryControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private jobControllerService = inject(JobsService);
  private loggingService = inject(LoggingService);

  columns: TableColumn[];
  filterFields: string[];
  crudAdapter: CrudAdapter<
    PagedModelEntityModelLipidMapsEntry,
    EntityModelLipidMapsEntry
  >;
  fileOptions: string[];
  file: string;

  ngOnInit() {
    this.jobControllerService
      .listFilesForJobName("lipidMapsImportJob")
      .subscribe(
        response => {
          this.fileOptions = response?._embedded?.stringList;
        },
        error => {
          this.messageService.add({
            severity: "error",
            summary: "Job config failed",
            detail: "Job config failed to load"
          });
        }
      );
    this.columns = [
      /*{ field: "id", header: "Id", filterType: ColumnFilterType.Text },*/
      {
        field: "id",
        header: "Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "transactionUuid",
        header: "Transaction",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "normalizedName",
        header: "Shorthand Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "name",
        header: "Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "systematicName",
        header: "Systematic Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "abbreviation",
        header: "LIPID MAPS Abbr",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "lmClassificationCode",
        header: "LIPID MAPS Class",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "nativeId",
        header: "LIPID MAPS Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "nativeUrl",
        header: "LIPID MAPS Entry",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "level",
        header: "Level",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      // {
      //   field: "label",
      //   header: "Label",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      // {
      //   field: "name",
      //   header: "Name",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      // {
      //   field: "version",
      //   header: "Version",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      // {
      //   field: "uri",
      //   header: "Uri",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      {
        field: "visibility",
        header: "Visibility",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      }
    ];
    this.filterFields = this.columns.map(value => {
      return value.field;
    });
    this.crudAdapter = new LipidMapsEntryCrudAdapter(
      this.controller,
      this.messageService,
      this.confirmationService,
      this.loggingService
    );
  }

  importLipidMaps() {
    const jobFileInputDto: JobFileInputDto = {
      file: this.file
    };
    this.jobControllerService
      .startJob("lipidMapsImportJob", jobFileInputDto)
      .subscribe(
        response => {
          this.messageService.add({
            severity: "success",
            summary: "Job started",
            detail: "Job started successfully"
          });
        },
        error => {
          this.messageService.add({
            severity: "error",
            summary: "Job failed",
            detail: "Job failed to start"
          });
        }
      );
  }
}
class LipidMapsEntryCrudAdapter extends CrudAdapter<
  PagedModelEntityModelLipidMapsEntry,
  EntityModelLipidMapsEntry
> {
  constructor(
    private controller: LipidMapsEntryControllerService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    loggingService: LoggingService
  ) {
    super(messageService, confirmationService, loggingService);
  }

  get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<PagedModelEntityModelLipidMapsEntry> {
    return this.controller.lipidMapsEntryGet(
      page,
      size,
      sort,
      observe,
      reportProgress,
      options
    );
  }

  extractEntries(entries: any): EntityModelLipidMapsEntry[] {
    return <EntityModelLipidMapsEntry[]>entries?._embedded?.lipidMapsEntries;
  }

  saveSingle(
    entity: EntityModelLipidMapsEntry,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<EntityModelLipidMapsEntry> {
    return this.controller.lipidMapsEntrySaveSingle(
      <LipidMapsEntry>entity,
      observe,
      reportProgress,
      options
    );
  }
  deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object> {
    return this.controller.lipidMapsEntryDeleteById(id, observe, reportProgress, options);
  }
}
